import type { CertificationModule } from "@brookbush/types";

import CertificationHeader, {
	CertificationHeaderType,
} from "./CertificationHeader";
import CertificationNotifications from "./CertificationNotifications";
import CardGrid from "~/components/CardGrid";
import { useCertification } from "~/hooks";
import useCertificationModule from "~/hooks/useCertificationModule";
import CoursesCard from "~/pages/courses/components/CoursesCard";

const CertificationModule = () => {
	const { module } = useCertificationModule();
	const { certification } = useCertification();

	const isElectivesCategory = module.slug === "electives";

	return (
		<div className="mt-2 flex w-full flex-col items-center gap-4 sm:gap-6">
			<CertificationHeader
				certification={certification}
				module={module}
				type={
					isElectivesCategory
						? CertificationHeaderType.ELECTIVES
						: CertificationHeaderType.MODULE
				}
			/>

			<CertificationNotifications />

			{!!module.courses.length && (
				<div className="mt-0 flex w-full flex-col gap-2 sm:mt-1 sm:items-start">
					{isElectivesCategory && (
						<h2 className="max-w-max text-left font-semibold text-xl sm:text-2xl">
							Passed Electives:
						</h2>
					)}

					<CardGrid>
						{module.courses?.map((course) => (
							<div className="card-grid-node-basis" key={course._id}>
								<CoursesCard {...course} />
							</div>
						))}
					</CardGrid>
				</div>
			)}

			{!!module.recommendedElectiveCourses?.length && (
				<div className="mt-0 flex w-full flex-col gap-2 sm:mt-1 sm:items-start">
					<h2 className="max-w-max text-left font-semibold text-xl sm:text-2xl">
						Recommended Electives:
					</h2>

					<CardGrid>
						{module.recommendedElectiveCourses?.map((course) => (
							<div className="card-grid-node-basis" key={course._id}>
								<CoursesCard {...course} />
							</div>
						))}
					</CardGrid>
				</div>
			)}
		</div>
	);
};

export default CertificationModule;
